package one.healthium.profile.ui.weight_history

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.profile.ui.weight.WeightHistoryUiModel
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class WeightHistoryViewModel(
    private val userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(WeightHistoryUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()

    init {
        combine(
            userInteractor.observeUser(),
            appPreferences.isMetricFlow,
        ) { user, isMetric ->
            _state.update { state ->
                state.copy(
                    loading = false,
                    isMetric = isMetric,
                    weightHistory = user.weightLogs.map { weightHistory ->
                        WeightHistoryUiModel.fromModel(weightHistory)
                    }
                )
            }
        }
            .onStart {
                _state.update { state -> state.copy(loading = true) }
            }
            .catch {
                Logger.e("Failed to load user", it)
                uiMessages.add(UiMessage.throwable(it))
            }
            .launch()
    }

    fun onWeightHistoryDeleteClicked(uiModel: WeightHistoryUiModel) {
        launch {
            try {
                _state.update { state ->
                    state.copy(deleteInProgress = state.deleteInProgress + uiModel.id)
                }
                userInteractor.removeWeight(uiModel.date)
            } catch (e: Exception) {
                Logger.e("Failed to delete weight history", e)
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state ->
                    state.copy(deleteInProgress = state.deleteInProgress - uiModel.id)
                }
            }
        }
    }
}